module.exports = __webpack_public_path__ + "media/account/components/SignInPage/OauthAuth/icon_google-9f42c71d454abad3ef72377893910a22.png";